import { data } from '../../svg/Explore/data';
import { makeIcon } from '../makeIcon';

export const Explore = makeIcon(data, 'explore', 'Explore');

export default Explore;
